import React from "react";
const NoRecordFound = () => {
    return <div className="search-norecord-info">No Record Found.</div>;
};
export default NoRecordFound;